import { Check, TriangleAlert } from "lucide-react";

export function CampaignSectionStatusBadge({
  ready,
  readyLabel,
  pendingLabel,
  testId,
}: {
  ready: boolean;
  readyLabel: string;
  pendingLabel: string;
  testId: string;
}): React.JSX.Element {
  if (ready) {
    return (
      <span
        className="inline-flex items-center gap-1.5 rounded-full border border-success/30 bg-success-muted py-0.5 ps-0.5 pe-2.5 text-[0.75rem] font-semibold text-success"
        data-testid={testId}
      >
        <span
          className="grid size-[1.125rem] shrink-0 place-items-center rounded-full bg-success text-white"
          aria-hidden="true"
        >
          <Check size={11} strokeWidth={3} />
        </span>
        {readyLabel}
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border border-warning/40 bg-warning-muted px-2.5 py-[0.1875rem] text-[0.75rem] font-semibold text-warning"
      data-testid={testId}
    >
      <TriangleAlert size={12} aria-hidden="true" />
      {pendingLabel}
    </span>
  );
}
